import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQS = [
  {
    q: "Do I need an appointment to visit Abhayam Dental Clinic?",
    a: "While walk-ins are welcome, we highly recommend booking an appointment through WhatsApp or by calling us so we can minimise your waiting time and give you a dedicated consultation slot.",
  },
  {
    q: "Is dental treatment at your clinic painful?",
    a: "Absolutely not. We use modern anesthetics and pain-free techniques including rotary root canals, gentle scaling and precise implant procedures — most patients report zero discomfort.",
  },
  {
    q: "Do you treat children?",
    a: "Yes. We have a dedicated Kids Dentistry service with a friendly environment designed to help children feel calm, confident and comfortable during every visit.",
  },
  {
    q: "How much does a dental implant or root canal cost?",
    a: "Pricing varies based on individual needs. Our doctors will give you a transparent estimate after examination — with no hidden charges. Please contact us directly for detailed pricing.",
  },
  {
    q: "Do you offer emergency dental care?",
    a: "Yes, we provide same-day emergency care for pain, swelling, dental trauma and broken teeth during clinic hours (Mon–Sat, 9:30 AM – 7:00 PM). Please call ahead so we can prepare.",
  },
  {
    q: "How often should I visit the dentist?",
    a: "We recommend a professional cleaning and check-up every 6 months to prevent decay, gum disease and to catch issues early — even if you have no visible problems.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-20 sm:py-28"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center reveal">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#009688]/10 text-[#009688] text-xs font-semibold tracking-wide uppercase">
            FAQs
          </div>
          <h2 className="mt-5 text-4xl sm:text-5xl font-semibold tracking-tight text-[#1F2937] leading-[1.05]">
            Common questions, <span className="text-[#009688]">clear answers</span>.
          </h2>
          <p className="mt-5 text-lg text-[#1F2937]/65">
            Everything you may want to know before booking your first visit.
          </p>
        </div>

        <div className="mt-12 bg-white rounded-3xl border border-[#009688]/12 p-2 sm:p-4 shadow-[0_8px_30px_rgba(0,0,0,0.03)] reveal">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-[#009688]/8 last:border-0 px-3 sm:px-5"
              >
                <AccordionTrigger className="text-left text-[15.5px] sm:text-base font-semibold text-[#1F2937] py-5 hover:no-underline hover:text-[#009688]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[15px] text-[#1F2937]/70 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
